import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { CitiesService } from 'src/app/cms/cities/cities.service';
import { flatMap, first } from 'rxjs/operators';
import { GroupService } from '../group/group.service';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CitiesPickerResolve implements Resolve<any> {

  constructor(
    private cs: CitiesService,
    private gs: GroupService
  ) { }

  resolve(route: ActivatedRouteSnapshot){
    return this.gs.getGroup().pipe(
      first(),
      flatMap(group => {
        let params = {ac_group: group, limit: 999}
        return this.cs.updateCitiesPicker(params)
      })
    )
  }
}
